'use es6';

import http from 'hub-http/clients/apiClient';
import Categories from 'ContentUtils/constants/Categories';
import TemplateTypes from 'ContentUtils/constants/TemplateTypes';
const url = 'cosemail/v1/emails';
const templatesUrl = 'designmanager/v1/templates/paginated-usable-templates';
export function fetch() {
  return http.get(url, {
    query: {
      state__in: ['automated_for_form', 'automated_for_form_draft'],
      limit: 1000,
      property: ['name', 'id', 'state']
    }
  });
}
export function fetchNotificationEmails(ids) {
  // Content group has no notification emails, so don't need request email objects
  if (!ids || ids.length === 0) {
    return Promise.resolve({
      objects: []
    });
  }
  return http.get(url, {
    query: {
      id__in: ids
    }
  });
}
export function hardUpdate(id, data) {
  return http.put(`${url}/${id}`, {
    data
  });
}
export function bufferUpdate(id, data) {
  return http.put(`${url}/${id}/buffer`, {
    data
  });
}
export function updateEmailDetailsWithoutTimestamping(id, updatedFields) {
  return http.put(`${url}/${id}/update-without-timestamping`, {
    data: updatedFields
  });
}
export function fetchUsableDndTemplateAndReplaceTemplatePath(id) {
  return http.get(templatesUrl, {
    query: {
      categoryId: Categories.email.id,
      templateTypeId: TemplateTypes.byName.drag_drop_email.id,
      limit: 1,
      includeHidden: true
    }
  }).then(res => {
    if (res.results.objects && res.results.objects.length) {
      return hardUpdate(id, {
        templatePath: res.results.objects[0].path
      });
    }
    return Promise.reject(new Error('No available drag drop email templates'));
  });
}
export function create(data) {
  return http.post(url, {
    data: {
      name: data.name,
      associatedLandingPageId: data.pageId,
      state: 'AUTOMATED_FOR_FORM_DRAFT',
      subcategory: 'automated_for_form',
      templatePath: 'hubspot_default/email/responsive/email.html'
    }
  });
}
export function getAllEmails() {
  return http.get(`${url}/listing`, {
    query: {
      // Purposefully querying both archived and non-archived emails here
      offset: 0
    }
  });
}